import { useEffect, useState } from "react";

const useBetSdk = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const scriptId = "sportsbook-sdk-script";

    const loadSdk = () => {
      // ✅ If already available
      if (window.BetSdk) {
        setIsReady(true);
        return;
      }

      const existingScript = document.getElementById(scriptId);

      if (existingScript) {
        // ✅ Check if SDK became available later
        const checkInterval = setInterval(() => {
          if (window.BetSdk) {
            setIsReady(true);
            clearInterval(checkInterval);
          }
        }, 50);

        return;
      }

      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://stage.sportbook.work/assets/sdk/init.js";
      script.async = true;

      script.onload = () => setIsReady(true);
      script.onerror = () => console.error("SDK load failed");

      document.body.appendChild(script);
    };

    loadSdk();
  }, []);

  return isReady;
};

export default useBetSdk;